import { Flex, Box, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as MultisigLogo } from 'assets/multisig-logo.svg';
import { ReactComponent as MenuIcon } from 'assets/menu.svg';
import { ApplicationRoutes } from '../../../utils/routes';
import { ModalType } from '../../../utils/constants';
import WalletsWidget from '../../Header/WalletsWidget';
import NetworksWidget from '../../Header/NetworksWidget';
import { GlobalContext } from 'providers/Global';
import { useContext } from 'react';
import { useMediaQuery } from 'react-responsive'
import { useVisibility } from 'hooks/useVisibility';
import { ModalMenu } from './ModalMenu';
import NotificationBell from '../../NotificationBell';
import { getNetworkDisplayName } from 'utils/networkConfigStore';
import { useSigningConfirmation } from 'providers/SigningConfirmation';

export const Header = () => {
  const navigate = useNavigate();
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 768px)' })
  const { connectedNetwork, openModal } = useContext(GlobalContext);
  const { pendingRequest } = useSigningConfirmation();

  const [MenuModal, toggleMenuModal] = useVisibility(ModalMenu);

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      borderBottom="1px solid rgba(0, 0, 0, 0.1)"
      px={{ base: 4, md: 8 }}
      py={3}
      gap={3}
      h={16}
      position="relative"
      zIndex={pendingRequest ? 1400 : undefined}
      bg="white"
    >
      <Box display="flex" alignItems="center" cursor="pointer" gap={2} onClick={() => navigate(ApplicationRoutes.Base)}>
        <MultisigLogo width={34} height={34} />
        <Text size="2xl" variant="bodyBold">
          Hedera MultiSig
        </Text>
      </Box>
      {
        !isTabletOrMobile && (
          <Box display="flex" alignItems="center" gap={3}>
            <NotificationBell />
            {connectedNetwork?.startsWith('custom-') && (
              <Box
                as="button"
                px={3}
                py={1}
                bg="green.50"
                border="1px solid"
                borderColor="green.200"
                borderRadius="full"
                cursor="pointer"
                transition="all 0.15s"
                _hover={{ bg: 'green.100', borderColor: 'green.300' }}
                onClick={() => openModal(ModalType.PrivateNetworksDrawer)}
              >
                <Text fontSize="xs" fontWeight={600} color="green.600" whiteSpace="nowrap">
                  {getNetworkDisplayName(connectedNetwork)}
                </Text>
              </Box>
            )}
            <Flex
              sx={{
                height: '100%',
                opacity: !!connectedNetwork ? 1 : 0,
                visibility: !!connectedNetwork ? 'visible' : 'hidden',
                transition: "opacity 0.5s ease-in-out",
              }}
            >
              <WalletsWidget />
            </Flex>
            <NetworksWidget />
          </Box>
        )
      }
      {
        isTabletOrMobile && (
          <>
            <Flex display="flex" alignItems="center" gap={2}>
              <NotificationBell />
              <Flex
                cursor="pointer"
                w={6}
                h={6}
                mr={1}
                onClick={toggleMenuModal}
              >
                <MenuIcon />
              </Flex>
            </Flex>
            <MenuModal onClose={toggleMenuModal} />
          </>
        )
      }
    </Flex>
  );
};

Header.displayName = 'Header';
